import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class ContentPod extends Component {
    static propTypes = {
        title: PropTypes.any,
        collapsed: PropTypes.bool,
        className: PropTypes.string
    }

    static defaultProps = {
        title: null,
        collapsed: true
    }

    render() {
        return (
            <div className={this.props.className + ' content-pod ' + (this.props.collapsed ? 'collapsed' : '')}>
                <div className="content-pod__header">
                    {this.props.title}
                </div>
                {this.props.children}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/scripts/reusable/ContentPod/ContentPod.jsx